import { produce } from "immer";
import {
  GET_NEXT_OF_KIN,
  GET_NEXT_OF_KIN_SUCCESS,
  GET_NEXT_OF_KIN_FAILURE,
  SAVE_NEXT_OF_KIN,
  SAVE_NEXT_OF_KIN_SUCCESS,
  SAVE_NEXT_OF_KIN_FAILURE,
  // other
  FETCH_OTHER_CONTACTS,
  FETCH_OTHER_CONTACTS_SUCCESS,
  FETCH_OTHER_CONTACTS_FAILURE,
  ADD_OTHER_CONTACT,
  ADD_OTHER_CONTACT_SUCCESS,
  ADD_OTHER_CONTACT_FAILURE,
  EDIT_OTHER_CONTACT,
  EDIT_OTHER_CONTACT_SUCCESS,
  EDIT_OTHER_CONTACT_FAILURE,
  DELETE_OTHER_CONTACT,
  DELETE_OTHER_CONTACT_SUCCESS,
  DELETE_OTHER_CONTACT_FAILURE,
  TOGGLE_OTHER_KIN_MODAL,
  SEARCH_CONTACTS,
  SEARCH_CONTACTS_SUCCESS,
  SEARCH_CONTACTS_FAILURE,
  GET_CONTACT_SUGGESTIONS,
  GET_CONTACT_SUGGESTIONS_SUCCESS,
  GET_CONTACT_SUGGESTIONS_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingKins: false,
  primaryContact: {},
  secondaryContact: {},
  otherContacts: {},
  isSubmitting: false,
  isDeleting: false,
  otherKinModal: { open: false },
  searchContactsList: [],
  isSearchingContacts: false,
  contactSuggestions: [],
  isFetchingContactSuggestions: false,
};

const ResidentNetworkReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case GET_NEXT_OF_KIN:
        draft.isFetchingKins = true;
        break;
      case GET_NEXT_OF_KIN_SUCCESS:
        draft.isFetchingKins = false;
        draft.primaryContact = action.payload.primaryContact;
        draft.secondaryContact = action.payload.secondaryContact;
        break;
      case GET_NEXT_OF_KIN_FAILURE:
        draft.isFetchingKins = false;
        break;
      case SAVE_NEXT_OF_KIN:
        draft.isFetchingKins = true;
        break;
      case SAVE_NEXT_OF_KIN_SUCCESS:
        draft.isFetchingKins = false;
        break;
      case SAVE_NEXT_OF_KIN_FAILURE:
        draft.isFetchingKins = false;
        break;
      case FETCH_OTHER_CONTACTS:
        draft.isFetchingOtherContacts = true;
        break;
      case FETCH_OTHER_CONTACTS_SUCCESS:
        draft.isFetchingOtherContacts = false;
        // If loading more pages (page > 1), append data to existing data
        if (
          action.payload?.current_page > 1 &&
          draft.otherContacts?.data &&
          Array.isArray(draft.otherContacts.data) &&
          Array.isArray(action.payload.data)
        ) {
          draft.otherContacts = {
            ...action.payload,
            data: [...draft.otherContacts.data, ...action.payload.data],
          };
        } else {
          // First page or initial load - replace data
          draft.otherContacts = action.payload;
        }
        break;
      case FETCH_OTHER_CONTACTS_FAILURE:
        draft.isFetchingOtherContacts = false;
        break;
      case ADD_OTHER_CONTACT:
        draft.isSubmitting = true;
        break;
      case ADD_OTHER_CONTACT_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_OTHER_CONTACT_FAILURE:
        draft.isSubmitting = false;
        break;
      case EDIT_OTHER_CONTACT:
        draft.isSubmitting = true;
        break;
      case EDIT_OTHER_CONTACT_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_OTHER_CONTACT_FAILURE:
        draft.isSubmitting = false;
        break;
      case DELETE_OTHER_CONTACT:
        draft.isDeleting = true;
        break;
      case DELETE_OTHER_CONTACT_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_OTHER_CONTACT_FAILURE:
        draft.isDeleting = false;
        break;
      case TOGGLE_OTHER_KIN_MODAL:
        draft.otherKinModal = action.payload;
        break;
      case SEARCH_CONTACTS:
        draft.isSearchingContacts = true;
        draft.searchContactsList = [];
        break;
      case SEARCH_CONTACTS_SUCCESS:
        draft.isSearchingContacts = false;
        // Extract data array from paginated response, or use payload directly if it's already an array
        draft.searchContactsList = Array.isArray(action.payload)
          ? action.payload
          : (action.payload?.data ?? []);
        break;
      case SEARCH_CONTACTS_FAILURE:
        draft.isSearchingContacts = false;
        draft.searchContactsList = [];
        break;
      case GET_CONTACT_SUGGESTIONS:
        draft.isFetchingContactSuggestions = true;
        draft.contactSuggestions = [];
        break;
      case GET_CONTACT_SUGGESTIONS_SUCCESS:
        draft.isFetchingContactSuggestions = false;
        draft.contactSuggestions = action.payload;
        break;
      case GET_CONTACT_SUGGESTIONS_FAILURE:
        draft.isFetchingContactSuggestions = false;
        draft.contactSuggestions = [];
        break;
      default:
        return state;
    }
  });

export default ResidentNetworkReducer;
